export default "<p>table-detail-driver works!</p>\n"